import { useTranslation } from 'react-i18next';
import { useSaveExperience } from '@/features/interactions/save';
import { Box, Button, Icon, Tooltip } from '@/ui';

export const SaveToLibraryButton = () => {
  const { t } = useTranslation('save');
  const { ariaLabel, isPreview, isSaved, tooltip, toggleSave } =
    useSaveExperience();
  const label = isSaved ? t('saved') : t('save_plan');
  const accessibleName = isSaved ? `${label}. ${ariaLabel}` : label;

  if (isPreview) {
    return null;
  }

  return (
    <Tooltip label={tooltip} placement="bottom" variant="simple">
      <Button
        _hover={{ bg: 'brand.40', color: 'brand.600' }}
        aria-label={accessibleName}
        color="brand.500"
        fontWeight={700}
        gap={1.5}
        size="ah"
        variant="ahGhost"
        onClick={toggleSave}
      >
        <Icon
          fill={isSaved ? 'currentColor' : 'none'}
          icon="Bookmark"
          size={4}
        />
        <Box as="span" display={{ base: 'none', md: 'inline' }}>
          {label}
        </Box>
      </Button>
    </Tooltip>
  );
};
